import type { ComplianceSubHeading } from '@/types/compliance';

interface ComplianceHeaderProps {
  subHeadings: ComplianceSubHeading[];
}

export default function ComplianceHeader({ subHeadings }: ComplianceHeaderProps) {
  if (subHeadings.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {subHeadings.map((sh) => (
        <div
          key={sh.id}
          className="rounded-2xl border border-[#e4e4e4] bg-white p-5 shadow-sm sm:p-6"
        >
          <p className="font-figtree text-[10px] font-bold uppercase tracking-[0.2em] text-[#A09A93]">
            {sh.heading}
          </p>
          <div
            className="mt-2 text-sm leading-relaxed text-[#1C1917] [&_a]:font-medium [&_a]:text-[#ed1c25] [&_a]:underline [&_a]:decoration-[#ed1c25]/30 [&_a:hover]:decoration-[#ed1c25]"
            dangerouslySetInnerHTML={{ __html: sh.description }}
          />
        </div>
      ))}
    </div>
  );
}
